// Attendance failures must not expose raw backend text or label every failure as a full match.
export function participationErrorKey(error: any): string {
  if (error?.status === 409 && error?.error?.code === 'PARTICIPATION_CHANGED') {
    return 'guestOwner.notices.participationChangedMessage';
  }
  if (error?.status === 406) return 'errors.maxPlayers';
  if (error?.status === 0) return 'errors.offline';
  if ([401, 403].includes(error?.status)) return 'errors.authorization';
  return 'events.saveResponseError';
}
